import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: string;
  centered?: boolean;
  light?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  centered = false,
  light = false
}: SectionHeadingProps) {
  const textColor = light ? 'text-[#fffdfb]' : 'text-[#24212a]';
  const introColor = light ? 'text-[#e9e1f6]' : 'text-[#5e5968]';
  const eyebrowColor = light ? 'text-[#decdf7]' : 'text-[#6D28D9]';
  return <div className={`${centered ? 'mx-auto text-center' : ''} max-w-3xl`} data-id="element-143" data-mp="bmpulighv8pi">
      {eyebrow && <p className={`mb-3 text-xs font-bold uppercase tracking-[0.18em] ${eyebrowColor}`} data-id="element-144" data-mp="glawdmbea0g2">
          {eyebrow}
        </p>}
      <h2 className={`font-serif text-3xl font-semibold leading-[1.06] tracking-[-0.035em] sm:text-4xl ${textColor}`} data-id="element-145" data-mp="6slnmz78b0of">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-base leading-7 ${introColor}`} data-id="element-146" data-mp="zahkjouyjk99">{intro}</p>}
    </div>;
}